import { RoundButton } from '@cian/ui-kit';
import { IconActionChevronDown16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './ScrollButton.css';

type TProps = {
  onClick: () => void;
};

export const ScrollButton: React.FC<TProps> = ({ onClick }) => {
  return (
    <div className={styles['container']}>
      <RoundButton
        title=""
        icon={<IconActionChevronDown16 color="control-main-primary-default" />}
        theme="fill_light"
        size="M"
        onClick={onClick}
      />
    </div>
  );
};
